import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VoyahFreeMomentsEditor = () => {
  const [form, setForm] = useState({
    titleEn: "",
    titleAr: "",
    titleKu: "",

    descEn: "",
    descAr: "",
    descKu: "",

    bottomTitleEn: "",
    bottomTitleAr: "",
    bottomTitleKu: "",

    bottomDescEn: "",
    bottomDescAr: "",
    bottomDescKu: "",

    buttonTextEn: "",
    buttonTextAr: "",
    buttonTextKu: ""
  });

  const [images, setImages] = useState({
    topImage: null,
    bottomImage: null,
    icons: [] // [{id, url}]
  });

  const [loading, setLoading] = useState(true);

  const [modalOpen, setModalOpen] = useState(false);
  const [uploadTarget, setUploadTarget] = useState(null);
  const [uploadFile, setUploadFile] = useState(null);

  const resolveUrl = (u) =>
    u?.startsWith("http") ? u : `${API_BASE}${u}`;

  useEffect(() => {
    const load = async () => {
      try {
        const [en, ar, ku] = await Promise.all([
          axios.get(`${API_BASE}/api/VFMomentsSection?lang=en`),
          axios.get(`${API_BASE}/api/VFMomentsSection?lang=ar`),
          axios.get(`${API_BASE}/api/VFMomentsSection?lang=ku`)
        ]);

        setForm({
          titleEn: en.data.title,
          descEn: en.data.description,

          bottomTitleEn: en.data.bottomTitle,
          bottomDescEn: en.data.bottomDesc,
          buttonTextEn: en.data.buttonText,

          titleAr: ar.data.title,
          descAr: ar.data.description,
          bottomTitleAr: ar.data.bottomTitle,
          bottomDescAr: ar.data.bottomDesc,
          buttonTextAr: ar.data.buttonText,

          titleKu: ku.data.title,
          descKu: ku.data.description,
          bottomTitleKu: ku.data.bottomTitle,
          bottomDescKu: ku.data.bottomDesc,
          buttonTextKu: ku.data.buttonText
        });

        setImages({
          topImage: en.data.topImage,
          bottomImage: en.data.bottomImage,
          icons: en.data.icons.map(ic => ({
            id: ic.id,
            img: ic.icon
          }))
        });

        setLoading(false);
      } catch (err) {
        console.error("Failed to load VFMomentsSection:", err);
      }
    };

    load();
  }, []);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSave = async () => {
    const token = localStorage.getItem("token");

    try {
      await axios.put(`${API_BASE}/api/VFMomentsSection/1`, form, {
        headers: { Authorization: `Bearer ${token}` }
      });

      alert("Updated successfully!");
    } catch (err) {
      console.error(err);
      alert("Failed to update.");
    }
  };

  const handleUpload = async () => {
    if (!uploadFile) return alert("Select a file first.");

    const token = localStorage.getItem("token");
    const fd = new FormData();

    if (uploadTarget === "topImage") fd.append("TopImage", uploadFile);
    if (uploadTarget === "bottomImage") fd.append("BottomImage", uploadFile);
    if (uploadTarget.startsWith("icon-")) {
      const id = uploadTarget.split("-")[1];
      fd.append("Icon", uploadFile);
      fd.append("IconId", id);
    }

    try {
      await axios.post(`${API_BASE}/api/VFMomentsSection/1/media`, fd, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        }
      });

      alert("Media updated!");
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("Upload failed.");
    }
  };

  if (loading) return <p>Loading...</p>;

  const LANGS = ["En", "Ar", "Ku"];

  return (
    <div className="container py-4">

      <h2 className="mb-4">Voyah FREE – Moments Section Editor</h2>

      {/* TEXT BLOCKS */}
      <div className="row">
        {LANGS.map((l) => (
          <div className="col-lg-4 mb-4" key={l}>
            <div className="card shadow-sm h-100">
              <div className="card-body">
                <h5>{l} Version</h5>

                <label className="form-label mt-2">Title</label>
                <input
                  className="form-control"
                  name={`title${l}`}
                  value={form[`title${l}`]}
                  onChange={handleChange}
                />

                <label className="form-label mt-2">Description</label>
                <textarea
                  className="form-control"
                  rows={3}
                  name={`desc${l}`}
                  value={form[`desc${l}`]}
                  onChange={handleChange}
                />

                <label className="form-label mt-2">Bottom Title</label>
                <input
                  className="form-control"
                  name={`bottomTitle${l}`}
                  value={form[`bottomTitle${l}`]}
                  onChange={handleChange}
                />

                <label className="form-label mt-2">Bottom Description</label>
                <textarea
                  className="form-control"
                  rows={3}
                  name={`bottomDesc${l}`}
                  value={form[`bottomDesc${l}`]}
                  onChange={handleChange}
                />

                <label className="form-label mt-2">Button Text</label>
                <input
                  className="form-control"
                  name={`buttonText${l}`}
                  value={form[`buttonText${l}`]}
                  onChange={handleChange}
                />

              </div>
            </div>
          </div>
        ))}
      </div>

      {/* SAVE BUTTON */}
      <div className="text-end">
        <button className="btn btn-primary px-4" onClick={handleSave}>
          Save Changes
        </button>
      </div>

      {/* IMAGES */}
      <h4 className="mt-5">Images</h4>

      {/* TOP IMAGE */}
      <div className="card mb-4">
        <div className="card-body">
          <h5>Top Image</h5>
          <img
            src={resolveUrl(images.topImage)}
            className="w-100 rounded mb-3"
            style={{ maxHeight: 300, objectFit: "cover" }}
          />

          <button
            className="btn btn-primary"
            onClick={() => {
              setUploadTarget("topImage");
              setModalOpen(true);
            }}
          >
            Replace
          </button>
        </div>
      </div>

      {/* BOTTOM IMAGE */}
      <div className="card mb-4">
        <div className="card-body">
          <h5>Bottom Image</h5>
          <img
            src={resolveUrl(images.bottomImage)}
            className="w-100 rounded mb-3"
            style={{ maxHeight: 300, objectFit: "cover" }}
          />

          <button
            className="btn btn-primary"
            onClick={() => {
              setUploadTarget("bottomImage");
              setModalOpen(true);
            }}
          >
            Replace
          </button>
        </div>
      </div>

      {/* ICONS */}
      <h4>Icons</h4>

      {images.icons.map((ic) => (
        <div className="card mb-4" key={ic.id}>
          <div className="card-body">
            <h5>Icon {ic.id}</h5>
            <img
              src={resolveUrl(ic.img)}
              className="rounded mb-3"
              style={{ height: 80 }}
            />

            <button
              className="btn btn-primary"
              onClick={() => {
                setUploadTarget(`icon-${ic.id}`);
                setModalOpen(true);
              }}
            >
              Replace Icon
            </button>
          </div>
        </div>
      ))}

      {/* MODAL */}
      {modalOpen && (
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Upload File</h5>
                  <button
                    className="btn-close"
                    onClick={() => setModalOpen(false)}
                  />
                </div>
                <div className="modal-body">
                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) => setUploadFile(e.target.files[0])}
                  />
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setModalOpen(false)}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-primary" onClick={handleUpload}>
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show" />
        </>
      )}

    </div>
  );
};

export default VoyahFreeMomentsEditor;
